module.exports = __webpack_public_path__ + "static/car-dial-90a0f1217d6dc0e0b945c3a1c79d213d.jpg";